import { getRouteApi } from '@tanstack/react-router';
import * as React from 'react';

import { CampaignDetailScreen } from '@/routes/admin/campaigns/campaign-detail-screen';

// =============================================================================
// campaign-detail-route.tsx — Adaptateur routeur de l'écran « Détail campagne » (hub/config).
// =============================================================================
// L'id de campagne est le path param d'URL (« /admin/campaigns/$campaignId ») — ressource d'URL,
// cohérent avec le contrat API (id server-set côté back). Le composant de présentation reste
// testable hors routeur.
//
// Le détail est l'enfant INDEX du layout de zone (campaign-zone-layout-route). Toute la navigation
// transverse (fil d'Ariane → registre, intitulé → hub, onglets des vues avec page courante mise en
// évidence) est portée par ce layout via <CampaignZoneNav> — plus aucun handler de navigation n'est
// injecté ici : le hub ne rend que son contenu de configuration/pilotage.

const routeApi = getRouteApi('/admin/campaigns/$campaignId/');

export function CampaignDetailRoute(): React.JSX.Element {
  const { campaignId } = routeApi.useParams();
  return <CampaignDetailScreen campaignId={campaignId} />;
}
